import kirby from '../../api/kirby'

// initial state
const state = {
  app: [],
  categories: [],
  items: []
}

// getters
const getters = {

  getCategoryById: state => id => {
    if (typeof state.categories[id] === 'undefined') { return null }
    return state.categories[id]
  },
  getItemById: state => id => {
    if (typeof state.items[id] === 'undefined') { return null }
    return state.items[id]
  },
  getCategoryItems: (state) => (categoryId) => {
    return Object.values(state.items).filter(item => item.categoryId === categoryId)
  }
}

// actions
const actions = {

  async init ({ state, commit, getters }) {
    // Categories
    fetch('/ueat/categories.json')
      .then(r => r.json())
      .then(categories => {
        commit('ueatCategories', categories)
      })

    // Items
    fetch('/ueat/items.json')
      .then(r => r.json())
      .then(items => {
        commit('ueatItems', items)
      })
  }
}

// mutations
const mutations = {
  ueatInit (state, { app }) {
    state.app.push(app)
  },
  ueatUpdate (state, { page, index }) {
    state.app.splice(index, 1, page)
  },
  ueatCategories (state, categories) {
    state.categories = categories
  },
  ueatItems (state, items) {
    state.items = items
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
